module.exports = __webpack_public_path__ + "img/sect4-3.ede83a09.png";